import { lazyLoad } from 'utils/loadable';

export const HrisConnectionsPage = lazyLoad(
  () => import('./index'),
  module => module.HrisConnectionsPage,
);